/* eslint-disable */

export const moroccoCities = [
  { name: "الدار البيضاء", hide: true, price: "50", wilaya_code: "01" },
  { name: "الرباط", hide: true, price: "50", wilaya_code: "02" },
  { name: "فاس", hide: true, price: "50", wilaya_code: "03" },
  { name: "مراكش", hide: true, price: "50", wilaya_code: "04" },
  { name: "طنجة", hide: true, price: "50", wilaya_code: "05" },
  { name: "أكادير", hide: true, price: "50", wilaya_code: "06" },
  { name: "مكناس", hide: true, price: "50", wilaya_code: "07" },
  { name: "وجدة", hide: true, price: "50", wilaya_code: "08" },
  { name: "القنيطرة", hide: true, price: "50", wilaya_code: "09" },
  { name: "تطوان", hide: true, price: "50", wilaya_code: "10" },
  { name: "آسفي", hide: true, price: "50", wilaya_code: "11" },
  { name: "خريبكة", hide: true, price: "50", wilaya_code: "12" },
  { name: "الجديدة", hide: true, price: "50", wilaya_code: "13" },
  { name: "بني ملال", hide: true, price: "50", wilaya_code: "14" },
  { name: "الناظور", hide: true, price: "50", wilaya_code: "15" },
  { name: "بركان", hide: true, price: "50", wilaya_code: "16" },
  { name: "سلا", hide: true, price: "50", wilaya_code: "17" },
  { name: "الصويرة", hide: true, price: "50", wilaya_code: "18" },
  { name: "الخميسات", hide: true, price: "50", wilaya_code: "19" },
  { name: "تزنيت", hide: true, price: "50", wilaya_code: "20" },
  { name: "محاية", hide: true, price: "50", wilaya_code: "21" },
  { name: "عين تاوجطات", hide: true, price: "50", wilaya_code: "22" },
  { name: "سبع عيون", hide: true, price: "50", wilaya_code: "23" },
  { name: "بوفكران", hide: true, price: "50", wilaya_code: "24" },
  { name: "الحاجب", hide: true, price: "50", wilaya_code: "25" },
  { name: "أزرو", hide: true, price: "50", wilaya_code: "26" },
  { name: "إفران", hide: true, price: "50", wilaya_code: "27" },
  { name: "تيزنيت", hide: true, price: "50", wilaya_code: "28" },
  { name: "الرشيدية", hide: true, price: "50", wilaya_code: "29" },
  { name: "تنغير", hide: true, price: "50", wilaya_code: "30" },
  { name: "ميدلت", hide: true, price: "50", wilaya_code: "31" },
  { name: "قلعة مكونة", hide: true, price: "50", wilaya_code: "32" },
  { name: "ورزازات", hide: true, price: "50", wilaya_code: "33" },
  { name: "الفقيه بن صالح", hide: true, price: "50", wilaya_code: "34" },
  { name: "سطات", hide: true, price: "50", wilaya_code: "35" },
  { name: "المحمدية", hide: true, price: "50", wilaya_code: "36" },
  { name: "تمارة", hide: true, price: "50", wilaya_code: "37" },
  { name: "سيدي قاسم", hide: true, price: "50", wilaya_code: "38" },
  { name: "سيدي سليمان", hide: true, price: "50", wilaya_code: "39" },
  { name: "شفشاون", hide: true, price: "50", wilaya_code: "40" },
  { name: "الحسيمة", hide: true, price: "50", wilaya_code: "41" },
  { name: "الدريوش", hide: true, price: "50", wilaya_code: "42" },
  { name: "جرادة", hide: true, price: "50", wilaya_code: "43" },
  { name: "تاوريرت", hide: true, price: "50", wilaya_code: "44" },
  { name: "جرسيف", hide: true, price: "50", wilaya_code: "45" },
];

export const tunisiaCities = [
  { name: "تونس", hide: true, price: "50", wilaya_code: "01" },
  { name: "أريانة", hide: true, price: "50", wilaya_code: "02" },
  { name: "بن عروس", hide: true, price: "50", wilaya_code: "03" },
  { name: "منوبة", hide: true, price: "50", wilaya_code: "04" },
  { name: "نابل", hide: true, price: "50", wilaya_code: "05" },
  { name: "زغوان", hide: true, price: "50", wilaya_code: "06" },
  { name: "بنزرت", hide: true, price: "50", wilaya_code: "07" },
  { name: "باجة", hide: true, price: "50", wilaya_code: "08" },
  { name: "جندوبة", hide: true, price: "50", wilaya_code: "09" },
  { name: "الكاف", hide: true, price: "50", wilaya_code: "10" },
  { name: "سليانة", hide: true, price: "50", wilaya_code: "11" },
  { name: "القيروان", hide: true, price: "50", wilaya_code: "12" },
  { name: "القصرين", hide: true, price: "50", wilaya_code: "13" },
  { name: "سيدي بوزيد", hide: true, price: "50", wilaya_code: "14" },
  { name: "سوسة", hide: true, price: "50", wilaya_code: "15" },
  { name: "المنستير", hide: true, price: "50", wilaya_code: "16" },
  { name: "المهدية", hide: true, price: "50", wilaya_code: "17" },
  { name: "صفاقس", hide: true, price: "50", wilaya_code: "18" },
  { name: "قابس", hide: true, price: "50", wilaya_code: "19" },
  { name: "مدنين", hide: true, price: "50", wilaya_code: "20" },
  { name: "تطاوين", hide: true, price: "50", wilaya_code: "21" },
  { name: "قبلي", hide: true, price: "50", wilaya_code: "22" },
  { name: "توزر", hide: true, price: "50", wilaya_code: "23" },
  { name: "قصر هلال", hide: true, price: "50", wilaya_code: "24" },
];

export const egyptCities = [
  { name: "القاهرة", hide: true, price: "50", wilaya_code: "01" },
  { name: "الجيزة", hide: true, price: "50", wilaya_code: "02" },
  { name: "الإسكندرية", hide: true, price: "50", wilaya_code: "03" },
  { name: "الدقهلية", hide: true, price: "50", wilaya_code: "04" },
  { name: "البحيرة", hide: true, price: "50", wilaya_code: "05" },
  { name: "الشرقية", hide: true, price: "50", wilaya_code: "06" },
  { name: "المنوفية", hide: true, price: "50", wilaya_code: "07" },
  { name: "الغربية", hide: true, price: "50", wilaya_code: "08" },
  { name: "القليوبية", hide: true, price: "50", wilaya_code: "09" },
  { name: "كفر الشيخ", hide: true, price: "50", wilaya_code: "10" },
  { name: "دمياط", hide: true, price: "50", wilaya_code: "11" },
  { name: "بورسعيد", hide: true, price: "50", wilaya_code: "12" },
  { name: "الإسماعيلية", hide: true, price: "50", wilaya_code: "13" },
  { name: "السويس", hide: true, price: "50", wilaya_code: "14" },
  { name: "الفيوم", hide: true, price: "50", wilaya_code: "15" },
  { name: "بني سويف", hide: true, price: "50", wilaya_code: "16" },
  { name: "المنيا", hide: true, price: "50", wilaya_code: "17" },
  { name: "أسيوط", hide: true, price: "50", wilaya_code: "18" },
  { name: "سوهاج", hide: true, price: "50", wilaya_code: "19" },
  { name: "قنا", hide: true, price: "50", wilaya_code: "20" },
  { name: "الأقصر", hide: true, price: "50", wilaya_code: "21" },
  { name: "أسوان", hide: true, price: "50", wilaya_code: "22" },
  { name: "مطروح", hide: true, price: "50", wilaya_code: "23" },
  { name: "البحر الأحمر", hide: true, price: "50", wilaya_code: "24" },
  { name: "الوادي الجديد", hide: true, price: "50", wilaya_code: "25" },
  { name: "جنوب سيناء", hide: true, price: "50", wilaya_code: "26" },
  { name: "شمال سيناء", hide: true, price: "50", wilaya_code: "27" },
];


